import { Linkedin, Github, Mail } from "lucide-react";

const Footer = () => {
  const socialLinks = [
    { icon: Linkedin, href: "https://www.linkedin.com/in/gulshan98/", label: "LinkedIn" },
    { icon: Github, href: "https://github.com/im-gulshan", label: "GitHub" },
    { icon: Mail, href: "mailto:gulshan.sdet@gmail.com", label: "Email" },
  ];

  return (
    <footer className="bg-gray-800 dark:bg-gray-950 text-white dark:text-gray-300 transition-colors duration-300">
      {/* Gradient separator */}
      <div className="h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500" />

      <div className="container mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Social Links */}
          <div className="flex gap-3">
            {socialLinks.map((social, i) => (
              <a
                key={i}
                href={social.href}
                target={social.href.startsWith("http") ? "_blank" : undefined}
                rel={social.href.startsWith("http") ? "noopener noreferrer" : undefined}
                className="w-10 h-10 rounded-full bg-gray-700 dark:bg-gray-800 flex items-center justify-center hover:bg-blue-600 dark:hover:bg-blue-600 transition-all duration-300 hover:-translate-y-1"
                aria-label={social.label}
              >
                <social.icon size={18} />
              </a>
            ))}
          </div>

          {/* Copyright */}
          <p className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} Gulshan Kumar. All rights reserved.
          </p>

        </div>
      </div>
    </footer>
  );
};

export default Footer;